module.exports = __webpack_public_path__ + "static/media/logomejia.e71ef66c.png";